import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';

import {
  CONFIRM_BUTTON_TEXT,
  DIALOG_MESSAGE,
  DIALOG_TITLE,
} from './messaging-campaign-archive.constants';

export type MessagingCampaignArchiveConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
};

export const MessagingCampaignArchiveConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
}: MessagingCampaignArchiveConfirmDialogProps) => {
  return (
    <ConfirmDialog
      dialogTitle={DIALOG_TITLE}
      onClose={onClose}
      open
      maxWidth='sm'
      confirmButtonText={CONFIRM_BUTTON_TEXT}
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
        color: 'error',
      }}
    >
      {loading && <LinearProgress />}
      <Typography>{DIALOG_MESSAGE}</Typography>
    </ConfirmDialog>
  );
};
